<template>
    <m-slide-up :show="show" @close="$emit('close')">
        <div class="px-7 space-y-4 ">
            <div class="flex items-center justify-between">
                <h1 class="font-bold text-xl">Sacrament Attendance</h1>

                <button class="-mt-1" @click="() => $emit('add')">
                    <church-icon class="!text-black !w-8  !h-8" icon="plus-circle-solid" />
                </button>
            </div>

            <m-search-field @input="text => searchString = text"/>
        </div>
        <div class="relative max-h-[75vh] overflow-y-auto pb-20">
            <div class="px-7">
                <table class="w-full ">
                <thead class="sticky top-0 bg-white">
                    <tr class="text-sm border-b border-gray-1">
                        <th class="py-3 px-2">Expected</th>
                        <th class="py-3 px-2">Total</th>
                        <th class="py-3 px-2">Ward</th>
                        <th class="py-3 px-2">Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="modifiedAttendanceList.length == 0">
                        <td colspan="4" class="text-center py-3 text-gray-1">No record</td>
                    </tr>
                     <tr v-for="(item, index) in modifiedAttendanceList" :key="index" class="invisible">
                        <td class="px-2"><div class="h-0">{{ item.total_number_of_attendees }}</div></td>
                        <td class="px-2"><div class="h-0">{{ item.number_of_attendees }}</div></td>
                        <td class="px-2 whitespace-nowrap"><div class="h-0">{{ getWardName(item.ward) }}</div></td>
                        <td class="px-2"><div class="h-0">{{ item.date_attendance }}</div></td>
                    </tr>
                </tbody>
            </table>
            </div>

            <div class="w-screen overflow-hidden h-full block">
                <m-slide-left-list-reveal 
                    @edit="() => $emit('edit', item)"
                    @delete="() => $emit('delete', item)"
                    v-for="(item, index) in modifiedAttendanceList" :key="index">
                    <table class="w-full text-left">
                        <thead class="invisible">
                            <tr class="text-sm">
                                <th class=" px-2 "><div class="h-0">Expected</div></th>
                                <th class=" px-2 "><div class="h-0">Total</div></th>
                                <th class=" px-2 "><div class="h-0">{{getLongestWardName}}</div></th>
                                <th class=" px-2 "><div class="h-0">Date</div></th>
                            </tr>
                        </thead>
                        <tbody>
                           <tr>
                                <td class=" px-2">{{ item.total_number_of_attendees }}</td>
                                <td class=" px-2">{{ item.number_of_attendees }}</td>
                                <td class=" px-2 whitespace-nowrap">{{ getWardName(item.ward) }}</td>
                                <td class=" px-2">{{ item.date_attendance }}</td>
                           </tr>
                        </tbody>
                    </table>
            </m-slide-left-list-reveal>
            </div>
        </div>
    </m-slide-up>
</template>

<script setup>
import DateUtils from '@/helpers/dateUtls';
import { computed, defineProps, ref } from 'vue';


/* ======= PROPS ===== */
const props = defineProps({
    show: { type: Boolean, default: false },
    attendanceList : { type: Array, default: () => [] },
    wards : { type: Array, default: () => [] }
})

/* ========== STATES ====== */
const searchString = ref('');

/* ======= COMPUTED ======== */
/**
 * Modified attendance list for rendering
 */
const modifiedAttendanceList = computed(() => {
    return props.attendanceList.map(item => {
        return item.attendance_report?.map?.(at => ({
                ...at,
                date_attendance: DateUtils.dateFormat({
                    date: item?.date_of_attendance || at?.date_attendance,
                    format: 'MM/DD/YYYY',
                    timeZone: false,
                    options: {originDateFormat : 'DD/MM/YYYY'}
                }),
                ward : at?.select_ward?.value
            }))
    })
    .flat(3)
    .filter(item => {
        if(!searchString.value) return true;
        return item.ward.toLowerCase().includes(searchString.value.toLowerCase()) ||
               item.date_attendance.toLowerCase().includes(searchString.value.toLowerCase()) ||
               item.total_number_of_attendees.toString().includes(searchString.value) ||
               item.number_of_attendees.toString().includes(searchString.value);
    })
})

/*
* Get longest ward name for table header
*/
const getLongestWardName = computed(() => {
    if (props.wards.length === 0) return 'Ward';
    return props.wards.reduce((longest, ward) => {
        return ward.header.length > longest.length ? ward.header : longest;
    }, '');
})
    

/* ======= METHODS ======= */
/**
 * Get ward name by domain
 * @param {string} domain
 * @return {string}
 */
const getWardName = (domain) => {
    const ward = props.wards.find(ward => ward.site_domain === domain);
    return ward ? ward.header?.trim?.() : 'Unknown Ward';
}
</script>